import { createRouter, createWebHistory } from 'vue-router'


const publicRoutes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/registrate',
        name: 'registrate',
        component: () => import('../views/Registro.vue')
    },
    {
        path: '/confirmacionregistro',
        name: 'confirmacionregistro',
        component: () => import('../views/ConfirmacionRegistro.vue')
    },


    {
        path: '/acercade',
        name: 'acercade',
        component: () => import('@/views/Acercade.vue')
    },
    {
        path: '/faq',
        name: 'faq',
        component: () => import('@/views/Faq.vue')
    },
    {
        path: '/thankyou',
        name: 'thankyou',
        component: () => import('@/views/Thankyou.vue')
    },
    {
        path: '/acuerdo',
        name: 'acuerdo',
        component: () => import('@/views/Acuerdo.vue')
    },
    {
        path: '/registro',
        name: 'registro',
        component: () => import('@/views/Registro.vue')
    },
    {
        path: '/confirmaRegistro',
        name: 'confirmaRegistro',
        component: () => import('@/views/ConfirmaRegistro.vue')
    },
];

const routes = [
    ...publicRoutes,
    {
        path: '/:catchAll(.*)',
        name: 'notFound',
        meta: { requiresAuth: false },
        component: () => import('@/views/NotFound.vue')
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            // Retorna el selector del ID y habilita el comportamiento suave
            return {
                el: to.hash,
                behavior: 'smooth',
            };
        }
        // Si no hay hash, manda la página al inicio (arriba)
        return { top: 0 };
    }
});

router.beforeEach((to, from, next) => {
    next();
});

export default router